module.exports = __webpack_public_path__ + "files/e93491b219e4516a8f3bea575bb2623f.png";